export enum EventType {
  CLASS = 'Class',
  APPOINTMENT = 'Appointment',
  OPEN_SESSION = 'OpenSession',
  FREE_TRAINING = 'FreeTraining',
  SPECIAL_EVENT = 'SpecialEvent',
}

export interface IEvent {
  archived: boolean;
  id: string;
  uuid?: string;
  integerId: number;
  numericId: number;
  providerId: string;
  eventGroupId: string;
  eventSerieId: string;
  originalStart: string;
  start: string; // start time&date 2021-10-09T00:00:00.000Z
  end: string; // end time&date 2021-10-08T01:30:00.000Z
  name: string;
  description?: string;
  color: string;
  notes: string | null;
  cancelled: boolean;
  cancellationReason: string | null;
  seats: number;
  public: boolean;
  type: EventType;
  waitingListEnabled: boolean;
  locationId: string;
  resourceIds: string[];
  trainerIds: string[];
  multipleBookingEnabled: boolean;
  publicBookingEnabled: boolean;
  publicBookingWindowStart: string | null;
  publicBookingWindowEnd: string | null;
  publicCancellationEnabled: boolean;
  publicCancellationWindowStart: string | null;
  publicCancellationWindowEnd: string | null;
  publicCancellationRefundEnd: string | null;
  deleted: string | null;
  timeStamp: string | null;
  livestream: boolean;
  virtualClassUrl: string | null;
  liveStreamId: string | null;
  source?: string | null;
}

export interface IEventUpdate extends IEvent {
  sendEmail?: boolean;
}
